<template>
  <el-dialog
    title="修改登陆密码"
    :visible.sync="dialogShow"
    :close-on-click-modal="false"
    @close="closeDialog"
    @open="openDialog"
  >
    <el-form :model="form" :rules="rules" ref="form">
      <el-form-item
        label="原密码"
        :label-width="formLabelWidth"
        prop="oldPassword"
      >
        <el-input
          type="password"
          v-model="form.oldPassword"
          autocomplete="off"
          placeholder="请输入原密码"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="新密码"
        :label-width="formLabelWidth"
        prop="newPassword"
      >
        <el-input
          type="password"
          v-model="form.newPassword"
          autocomplete="off"
          placeholder="请输入新密码"
        ></el-input>
      </el-form-item>

      <el-form-item
        label="确认密码"
        :label-width="formLabelWidth"
        prop="newPasswordConfirm"
      >
        <el-input
          type="password"
          v-model="form.newPasswordConfirm"
          autocomplete="off"
          placeholder="请再次输入新密码"
        ></el-input>
      </el-form-item>
    </el-form>

    <div slot="footer" class="dialog-footer">
      <el-button @click="closeDialog">取 消</el-button>
      <el-button type="primary" @click="updatePassword">确 定</el-button>
    </div>
  </el-dialog>
</template>

<script>
import md5 from 'js-md5'

export default {
  name: 'SystemEdit',
  props: {
    show: Boolean,
    formData: Object,
    action: String,
  },
  data() {
    return {
      dialogShow: this.show,
      form: {
        newPasswordConfirm: '',
        newPassword: '',
        oldPassword: '',
      },
      formLabelWidth: '120px',
      rules: {
        oldPassword: [
          { required: true, message: '请输入原密码', trigger: 'blur' },
          // { min: 6, max: 20, message: "请输入6到20个字符", trigger: "blur" },
        ],
        newPassword: [
          { required: true, message: '请输入新密码', trigger: 'blur' },
          { min: 8, max: 20, message: '请输入8到20个字符', trigger: 'blur' },
        ],
        newPasswordConfirm: [
          { required: true, message: '请再次输入新密码', trigger: 'blur' },
          { min: 8, max: 20, message: '请输入8到20个字符', trigger: 'blur' },
        ],
      },
    }
  },
  methods: {
    openDialog() {},
    closeDialog() {
      this.dialogShow = false
      this.$refs['form'].resetFields() //关闭的时候重置表单
      this.$emit('update:show', false)
    },

    updatePassword() {
      this.$refs['form'].validate(valid => {
        if (valid) {
          let oldPassword = this.form.oldPassword
          let newPassword = this.form.newPassword
          let newPasswordConfirm = this.form.newPasswordConfirm

          this.axios
            .post('/sysUserInfo/updatePassword', {
              oldPassword: oldPassword,
              newPassword: newPassword,
              newPasswordConfirm: newPasswordConfirm,
            })
            .then(res => {
              if (res.code === 200) {
                this.$notify({
                  title: '更新成功',
                  message: res.msg,
                  type: 'success',
                })

                this.$store.commit('setIsLogin', false)
                this.$store.commit('setUserId', null)
                this.$store.commit('setUserName', null)
                this.$store.commit('setRoutes', [])
                this.$router.push('/login')

                this.closeDialog()
              } else {
                this.$notify.error({
                  title: '添加失败',
                  message: res.msg,
                })
              }
            })
        } else {
          return false
        }
      })
    },
  },
  watch: {
    show(newVal) {
      this.dialogShow = newVal
    },
  },
}
</script>

<style scoped>
</style>